import React from 'react';
import { Link } from 'react-router-dom';

const Hero: React.FC = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden">

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-50 dark:bg-dark-800/50 border border-primary-200 dark:border-dark-700 mb-8 animate-fade-in">
          <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
          <span className="text-sm text-slate-700 dark:text-dark-300 font-medium">Now available for new projects</span>
        </div>

        {/* Main Heading */}
        <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-display font-bold mb-6 animate-slide-up">
          <span className="text-slate-900 dark:text-white">Software that's</span>
          <br />
          <span className="gradient-text">simply Cimmple</span>
        </h1>

        {/* Subheading */}
        <p className="text-lg sm:text-xl text-slate-700 dark:text-dark-300 max-w-2xl mx-auto mb-10 animate-slide-up animate-delay-100">
          Trusted by manufacturing, construction, heat treatment, and other industries. 
          From logistics and job management, we make complexity simple. 
          Plus, CimmplePay automates payroll processing and compliance.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-slide-up animate-delay-200">
          <Link to="/products" className="btn-primary text-lg px-8 py-4">
            Explore Products
            <svg className="inline-block ml-2 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </Link>
          <Link to="/pricing" className="btn-secondary text-lg px-8 py-4">
            View Pricing
          </Link>
        </div>

        {/* Stats */}
        {/* <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8 animate-fade-in animate-delay-300">
          {[
            { value: '50+', label: 'Clients Served' },
            { value: '99.9%', label: 'Uptime' },
            { value: '24/7', label: 'Support' },
            { value: '5★', label: 'Rating' },
          ].map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-3xl md:text-4xl font-display font-bold text-slate-900 dark:text-white mb-2">
                {stat.value}
              </div>
              <div className="text-slate-600 dark:text-dark-400 text-sm font-medium">{stat.label}</div>
            </div>
          ))}
        </div> */}
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 rounded-full border-2 border-slate-400 dark:border-dark-600 flex justify-center pt-2">
          <div className="w-1 h-2 rounded-full bg-slate-500 dark:bg-dark-400" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
